import {FC, useEffect, useState} from 'react'
import {Modal, Spinner} from 'react-bootstrap'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {AdminRemoveCreditParams, CampType} from '../../../../../../services/cellcast.v2.types'
import {useAdminRemoveCreditMutation} from '../../../../../../services/cellcast.v2'
import {FixedTwoDecimal} from '../../../../../Utils/_helpers/string'
import {toast} from 'react-toastify'
import {REGION_ARRAYS} from '../../../../../Utils/Constant/ConstantForWebsite'
import Select from 'react-select'
import {AllocateCreditMode} from '../../../../../../services/cellcast.v3.types'
import {
  useAllocateCreditMutation,
  useRemainingBalanceRegionMutation,
} from '../../../../../../services/cellcast.v3'

export type RemoveCreditPopupProps = {
  show: boolean
  handleClose: () => void
  callbackFn: () => void
  userId: string
  userName: string
  smsCredit: number
  mmsCredit: number
}

const RemoveCreditPopup: FC<RemoveCreditPopupProps> = (props) => {
  const {show, userId, userName, smsCredit, mmsCredit, handleClose, callbackFn} = props

  const [smsLocalCredit, setSmsCredit] = useState(0)
  const [mmsLocalCredit, setMMsCredit] = useState(0)
  const [region, setRegion] = useState<any>(REGION_ARRAYS[0].value)
  const [note, setNote] = useState<any>('')

  const [params, setParams] = useState<AdminRemoveCreditParams>({
    noOfCredit: 0,
    campType: CampType.sms,
    userId: userId,
    note: ''
  })
  const [errorMessage, setErrorMessage] = useState('')

  const [removeCredit, {isLoading: removeCreditLoading}] = useAdminRemoveCreditMutation()
  const [allocateCredit, {isLoading: allocateCreditLoading}] = useAllocateCreditMutation()

  const [fetchBalanceRegion, {data: balanceRegionData, isLoading: balanceRegionDataLoading}] = useRemainingBalanceRegionMutation()

  const handleInputChange = (amountInput: string) => {
    setErrorMessage('')
    const amount = parseFloat(amountInput) || 0
    setParams({...params, noOfCredit: amount})

    let newSms = smsCredit - amount
    let newMms = mmsCredit - amount

    if (REGION_ARRAYS[0].value !== region) {
      newSms = (balanceRegionData?.data.sms || 0) - amount
      newMms = (balanceRegionData?.data.mms || 0) - amount
    } 

    if (params.campType === CampType.sms && newSms < 0) {
      setErrorMessage('sms balance is not enough')
    }
    if (params.campType === CampType.mms && newMms < 0) {
      setErrorMessage('sms balance is not enough')
    }

    
    setSmsCredit(newSms)
    setMMsCredit(newMms)
  }

  const handleSubmit = () => {
    if (params.noOfCredit === 0 || params.userId === '') {
      return
    }

    const payload = {
      ...params
    }

    if (note !== '') {
      payload.note = note
    }

    if (region === REGION_ARRAYS[0].value) {
      removeCredit(payload)
        .then((res) => {
          if ('data' in res) {
            toast.success(res.data?.message)
            setErrorMessage('')
            if (callbackFn) {
              callbackFn()
            }
          } else if ('error' in res) {
            const errObj = res.error as any
            setErrorMessage(errObj.data.message)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
      return
    } else {
      let allocateCreditAmount = params.noOfCredit
      if (typeof params.noOfCredit === 'string') {
        allocateCreditAmount = parseInt(params.noOfCredit)
      }

      allocateCredit({
        body: {
          action: 'allocate_credit',
          data: {
            balance_type: params.campType,
            credit: allocateCreditAmount,
            mode: AllocateCreditMode.subtract,
            target_user_id: params.userId,
          },
        },
        region: region,
      })
        .then((res) => {
          if ('data' in res) {
            toast.success(res.data?.message)
            setErrorMessage('')
            if (callbackFn) {
              callbackFn()
            }
          } else if ('error' in res) {
            const errObj = res.error as any
            setErrorMessage(errObj.data.message)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    }
  }

  useEffect(() => {
    setSmsCredit(smsCredit)
    setMMsCredit(mmsCredit)
  }, [smsCredit, mmsCredit])

  useEffect(() => {
    if (REGION_ARRAYS[0].value !== region) {
      fetchBalanceRegion({userId: userId, region: region})
    }
  }, [region])

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header border-bottom'>
          <h2>Remove credits</h2>
          <div className='btn btn-icon btn-sm' onClick={handleClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body pl-10 pr-10'>
          <div className='row mb-2'>
            <div className='border-end pe-15'>
              <div className='d-flex flex-column justify-content-center align-items-center w-100 mb-5'>
                <h3>User Balance {`(${userName})`}</h3>
     
                  <h1 style={{fontSize: 40}}>
                    {params.campType === CampType.sms
                      ? FixedTwoDecimal(smsLocalCredit)
                      : FixedTwoDecimal(mmsLocalCredit)}
                  </h1>
              
              </div>
              <div className='d-flex justify-content-center align-items-center gap-2'>
                <div>
                  <input
                    type='radio'
                    className='btn-check'
                    name='sms'
                    checked={params.campType === CampType.sms}
                    id='quick_sms_radio2'
                    onChange={() => {
                      setParams({...params, campType: CampType.sms})
                    }}
                  />
                  <label className='btn btn-light-info py-2 px-5' htmlFor='quick_sms_radio2'>
                    <span className='fw-500 fs-2'>SMS</span>
                  </label>
                </div>
                <div>
                  <input
                    type='radio'
                    className='btn-check'
                    name='mms'
                    checked={params.campType === CampType.mms}
                    id='quick_mms_radio2'
                    onChange={() => {
                      setParams({...params, campType: CampType.mms})
                    }}
                  />
                  <label
                    className='btn btn-active-info btn-light-info py-2 px-5'
                    htmlFor='quick_mms_radio2'
                  >
                    <span className='fw-500 fs-2'>MMS</span>
                  </label>
                </div>
              </div>

              <div className='mt-7 mb-10'>
                <label className=' col-form-label fw-normal fs-6'>Choose region</label>
                <Select
                  options={REGION_ARRAYS}
                  value={REGION_ARRAYS?.find((key: any) => key?.value === region)}
                  onChange={(e: any) => setRegion(e?.value)}
                  className='form-select form-select-solid form-select-lg'
                />
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'></div>
                </div>
              </div>

              <div className='mt-7'>
                <label className=' col-form-label fw-normal fs-6'>
                  How many messages are you take ?
                </label>
                <input
                  onChange={(e) => handleInputChange(e.target.value)}
                  name='Type'
                  type='text'
                  className='form-control form-control-lg form-control-solid mb-4 w-100 text-bg-light d-block'
                />
                {errorMessage && errorMessage.length > 0 && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block text-danger'>{errorMessage}</div>
                  </div>
                )}
              </div>

              <div className='mt-7'>
                <label className=' col-form-label fw-normal fs-6'>Note</label>
                <input
                  onChange={(e: any) => setNote(e.target.value)}
                  name='Note'
                  type='input'
                  className='form-control form-control-lg form-control-solid mb-4 w-100 text-bg-light d-block'
                />
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block text-danger'></div>
                </div>
              </div>
            </div>
            <div className='d-flex flex-center mt-20'>
              <div id='kt_drawer_chat_close'>
                <button
                  type='button'
                  onClick={handleClose}
                  className='btn btn-light text-hover-white rounded btn-active-primary me-3 w-100px p-3 fw-500 me-2'
                >
                  Discard
                </button>
              </div>

              <button
                disabled={params.noOfCredit === 0 || errorMessage !== ''}
                type='submit'
                className='btn btn-light btn-primary fw-500 rounded w-100px p-3 border border-primary'
                onClick={() => handleSubmit()}
              >
                <span className='indicator-label'>
                  {removeCreditLoading || allocateCreditLoading ? 'Processing' : 'Submit'}
                </span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default RemoveCreditPopup
